export default {
  "domain": "woopra.com",
  "click_tracking_matcher_selectors": [
    "a",
    "button",
    "input[type=button]",
    "input[type=submit]",
    "[role=button]"
  ],
  "download_extensions": [
    "avi",
    "doc",
    "eps",
    "exe",
    "js",
    "m4v",
    "mov",
    "mp3",
    "mp4",
    "msi",
    "pdf",
    "ppt",
    "rar",
    "svg",
    "txt",
    "vsd",
    "vxd",
    "wma",
    "wmv",
    "xls",
    "xlsx",
    "zip"
  ],
  "cookie_expire": 63072000,
  "region": "eu",
  "click_tracking": 0,
  "cookie_domain": ".woopra.com",
  "cookie_secure": 0,
  "download_tracking": 0,
  "hide_campaign": 1,
  "personalization": 1,
  "meta": {
    "id": 188,
    "revision": 16
  }
};